exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".privacy-info-row{margin-top:1rem;margin-bottom:1rem}.PrivacyInfo__index_row{padding-right:0}.PrivacyInfo__text_row{padding-left:0}.PrivacyInfo__terms{font-weight:bold}#root-container{overflow-y:scroll;overflow-x:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/PrivacyInfo/styles.scss
// module id = 785
// module chunks = 0